import React from 'react';
import {Schema} from "../../../types/Schema";

import DeleteSchemaAction from "../actions/DeleteSchemaAction";
import ActivateSchemaAction from "../actions/ActivateSchemaAction";
import DownloadSchemaAction from "../actions/DownloadSchemaAction";
import OpenSchemaAction from "../actions/OpenSchemaAction";
import UploadSchemaAction from "../actions/UploadSchemaAction";

import './SchemaRegistryActions.scss';

type SchemaRegistryActionsProps = {
  schema: Schema,
  onUpdate: () => void
  onAction: (executingAction: boolean) => void
};

/**
 * Renders action buttons for each schema in the table.
 */
class SchemaRegistryActions extends React.Component<SchemaRegistryActionsProps> {

  onUpdate = () => {
    this.props.onAction(false);
    // Notify parents that a schema was modified (i.e. activated or deleted) and reload is required
    this.props.onUpdate();
  };

  onBeginActivate = () => {
    this.props.onAction(true);
  };

  onFailedActivate = () => {
    this.props.onAction(false);
  };

  render() {
    return (
      <td className="SchemaRegistryActions">
        <OpenSchemaAction schema={this.props.schema.properties}/>
        <UploadSchemaAction schemaId={this.props.schema.properties.id}
                            forbidden={!this.props.schema.permissions.canWrite}/>
        <DownloadSchemaAction schemaId={this.props.schema.properties.id}/>
        {
          !this.props.schema.bound ? <>
            <DeleteSchemaAction schema={this.props.schema.properties}
                                forbidden={!this.props.schema.permissions.canDelete}
                                onDelete={this.onUpdate}/>
            <ActivateSchemaAction schemaId={this.props.schema.id}
                                  forbidden={!this.props.schema.permissions.canBind}
                                  onBeginActivate={this.onBeginActivate}
                                  onActivate={this.onUpdate}
                                  onFailedActivate={this.onFailedActivate}/>
          </> : null
        }
      </td>
    );
  }
}

export default SchemaRegistryActions;
